import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import IconSvg from 'Components/IconSvg';

const Select = ({ onSelect, options, translateOption, value }) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef();

  const handleClick = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  const handleSelect = (event, option) => {
    event.stopPropagation();
    onSelect(option);
    setIsOpen(false);
  };

  useEffect(() => {
    const onOutsideClick = (event) => {
      if (selectRef.current?.contains(event.target)) return;
      setIsOpen(false);
    };
    document.body.addEventListener('click', onOutsideClick);

    return () => {
      document.body.removeEventListener('click', onOutsideClick);
    };
  }, []);

  return (
    <div
      className={`select ${isOpen ? 'isOpen' : ''}`}
      onClick={handleClick}
      ref={selectRef}
    >
      <div className="select__header">
        <span className="select__text">{translateOption(value)}</span>
        <span className="select__icon">
          <IconSvg type="arrowDown" />
        </span>
      </div>
      <ul className="select__options">
        {options.map((option) => (
          <li
            className={value === option ? 'active' : ''}
            key={option}
            onClick={(event) => handleSelect(event, option)}
          >
            {translateOption(option)}
          </li>
        ))}
      </ul>
    </div>
  );
};

Select.propTypes = {
  onSelect: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  translateOption: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

Select.defaultProps = {};

export default Select;
